<template>
  <b-modal
    :id="id"
    size="md"
    okOnly
    noFade
    hideHeaderClose
    noCloseOnBackdrop
  >
    <template #modal-title>
      {{ $t(`apps.settings.permission.appid${dataModal.app_id}`) }}
      ->
      {{ $t(`apps.settings.permission.appid${dataModal.app_id}-moduleid${dataModal.module_id}`) }}
      <template v-if="dataModal.submodule_id">
        ->
        {{ $t(`apps.settings.permission.appid${dataModal.app_id}-moduleid${dataModal.module_id}-submoduleid${dataModal.submodule_id}`) }}
      </template>
    </template>
    <slot/>
    <template #modal-footer="{ ok, cancel, hide }">
      <div class="footer">
        <button
          class="btn btn-light"
          @click="handleCancel(ok)"
        >
          {{ $t('button.cancel') }}
        </button>
        <button
          class="btn btn-web"
          @click="handleSubmit(ok)"
        >
          {{ $t('button.apply') }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
    },
    dataModal: {
      type: Object,
    },
  },

  methods: {
    handleCancel(ok) {
      this.$emit('onCancel', ok)
    },
    handleSubmit(ok) {
      this.$emit('onSubmit', ok)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseModalPermissionSetting.vue